import { NavigationGuard } from 'vue-router';

const UNAVAILABLE_GUARD: NavigationGuard = async (to, from, next) => {
   const isUnderMaintenance = import.meta.env.VITE_APP_UNDER_MAINTENANCE === 'true';

   if (isUnderMaintenance && to.name !== 'Unavailable') {
      return next({ name: 'Unavailable' });
   }

   return next();
};

export default UNAVAILABLE_GUARD;
